import { EnvironmentProviders } from '@angular/core';
import { QueryClient, provideAngularQuery } from '@tanstack/angular-query-experimental';

export function provideQueryClient(): EnvironmentProviders {
  return provideAngularQuery(new QueryClient());
}
